import React from 'react';
import { useSelector } from 'react-redux';
import ComponentHazardTable from './ComponentHazardTable';
import ComponentHazardCheckBox from './ComponentHazardCheckBox';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../../helper';
import { RootState } from '../../../../redux/rootState';

function HazardAnalysis() {
  const { reportPdfResponse1, tableContent, reportPdfResponse4 } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  return (
    <div className="ExpenseReportPDFDiv">
      <div className="pageHeader">
        <div className="topHeader">
          <div>
            {ReportPart1(tableContent, CombineReportEnum.COMBINE_HAZARD_ANALYSIS, PDFReportEnum.PDF_HAZARD_ANALYSIS, 'Hazard Analysis')}
          </div>
          <div>{`S/N ${reportPdfResponse1?.JobOrderData?.SerialNumber}`}</div>
        </div>
        <div className="underlineHeadingText textCenter">Hazard Analysis</div>
      </div>
      {/* {reportPdfResponse4?.Hazard_Analysis?.[0]?.JobOrder && <ComponentHazardTable />} */}
      <ComponentHazardTable />
      <ComponentHazardCheckBox />
      {String(reportPdfResponse4?.Hazard_Analysis?.[0]?.Comment)?.length > 0 && (
      <div className="comments_hazard_analysis">
        <p>Comments:</p>
        {'\n'}
        {reportPdfResponse4?.Hazard_Analysis?.[0]?.Comment}
      </div>
      )}
    </div>
  );
}

export default HazardAnalysis;
